"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { buildRepAvatarItems } from "./buildRepAvatarItems";
import { RateMatter } from "@/types/enums";
import { AnimatePresence, motion } from "framer-motion";
import { useContext, useMemo, useState } from "react";
import UserPageIdentityHeaderCICRate from "../identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageRepModifyModal from "./modify-rep/UserPageRepModifyModal";
import GrantRepDialog from "./new-rep/GrantRepDialog";
import type { RepDirection } from "./UserPageRep.helpers";
import { getCanEditRep, getCanEditNic } from "./UserPageRep.helpers";
import MobileTabCards from "./MobileTabCards";
import MobileRepTabContent from "./MobileRepTabContent";
import MobileIdentityTabContent from "./MobileIdentityTabContent";
type MobileTab = "rep" | "identity";
export default function UserPageRepMobile(t0) {
  const $ = _c(67);
  const {
    profile,
    overview,
    categories,
    cicOverview,
    repDirection,
    onRepDirectionChange,
    initialActivityLogParams,
    loading,
    visibleCount,
    onShowMore,
    hasNextPage,
    isFetchingNextPage,
    onOpenOverviewContributors,
    onOpenCategoryContributors
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const {
    address
  } = useSeizeConnectContext();
  const [activeTab, setActiveTab] = useState("rep");
  const [isGrantRepOpen, setIsGrantRepOpen] = useState(false);
  const [isNicRateOpen, setIsNicRateOpen] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== profile) {
    t1 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = profile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const canEditRep = t1;
  let t2;
  if ($[4] !== activeProfileProxy || $[5] !== address || $[6] !== connectedProfile || $[7] !== profile) {
    t2 = getCanEditNic({
      connectedProfile,
      targetProfile: profile,
      activeProfileProxy,
      address
    });
    $[4] = activeProfileProxy;
    $[5] = address;
    $[6] = connectedProfile;
    $[7] = profile;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const canEditNic = t2;
  let t3;
  if ($[9] !== activeProfileProxy || $[10] !== address || $[11] !== profile) {
    t3 = !activeProfileProxy && !!profile.handle && (profile.wallets ?? []).some(w => w.wallet.toLowerCase() === address?.toLowerCase());
    $[9] = activeProfileProxy;
    $[10] = address;
    $[11] = profile;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const canEditStatements = t3;
  cicOverview?.contributors.data;
  let t4;
  if ($[13] !== cicOverview?.contributors.data) {
    t4 = buildRepAvatarItems(cicOverview?.contributors.data ?? [], 3, {
      omitHref: true
    });
    $[13] = cicOverview?.contributors.data;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const cicAvatarItems = t4;
  let t5;
  if ($[15] !== activeTab || $[16] !== cicAvatarItems || $[17] !== cicOverview || $[18] !== onOpenOverviewContributors || $[19] !== overview || $[20] !== profile || $[21] !== repDirection) {
    t5 = <MobileTabCards activeTab={activeTab} onTabChange={setActiveTab} overview={overview} cicOverview={cicOverview} profile={profile} repDirection={repDirection} cicAvatarItems={cicAvatarItems} onOpenOverviewContributors={onOpenOverviewContributors} />;
    $[15] = activeTab;
    $[16] = cicAvatarItems;
    $[17] = cicOverview;
    $[18] = onOpenOverviewContributors;
    $[19] = overview;
    $[20] = profile;
    $[21] = repDirection;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== activeTab || $[24] !== canEditNic || $[25] !== canEditRep || $[26] !== canEditStatements || $[27] !== categories || $[28] !== cicOverview || $[29] !== hasNextPage || $[30] !== initialActivityLogParams || $[31] !== isFetchingNextPage || $[32] !== loading || $[33] !== onOpenCategoryContributors || $[34] !== onRepDirectionChange || $[35] !== onShowMore || $[36] !== overview || $[37] !== profile || $[38] !== repDirection || $[39] !== visibleCount) {
    t6 = <AnimatePresence mode="wait">{activeTab === "rep" ? <motion.div key="rep" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}><MobileRepTabContent profile={profile} overview={overview} categories={categories} repDirection={repDirection} onRepDirectionChange={onRepDirectionChange} initialActivityLogParams={initialActivityLogParams} loading={loading} canEditRep={canEditRep} visibleCount={visibleCount} onShowMore={onShowMore} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} onGrantRep={() => setIsGrantRepOpen(true)} onEditCategory={setEditCategory} onOpenCategoryContributors={onOpenCategoryContributors} /></motion.div> : <motion.div key="identity" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}><MobileIdentityTabContent profile={profile} cicOverview={cicOverview} initialActivityLogParams={initialActivityLogParams} canEditNic={canEditNic} canEditStatements={canEditStatements} onRateNic={() => setIsNicRateOpen(true)} /></motion.div>}</AnimatePresence>;
    $[23] = activeTab;
    $[24] = canEditNic;
    $[25] = canEditRep;
    $[26] = canEditStatements;
    $[27] = categories;
    $[28] = cicOverview;
    $[29] = hasNextPage;
    $[30] = initialActivityLogParams;
    $[31] = isFetchingNextPage;
    $[32] = loading;
    $[33] = onOpenCategoryContributors;
    $[34] = onRepDirectionChange;
    $[35] = onShowMore;
    $[36] = overview;
    $[37] = profile;
    $[38] = repDirection;
    $[39] = visibleCount;
    $[40] = t6;
  } else {
    t6 = $[40];
  }
  let t7;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsGrantRepOpen(false);
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  let t8;
  if ($[42] !== isGrantRepOpen || $[43] !== overview || $[44] !== profile) {
    t8 = <GrantRepDialog profile={profile} overview={overview} isOpen={isGrantRepOpen} onClose={t7} />;
    $[42] = isGrantRepOpen;
    $[43] = overview;
    $[44] = profile;
    $[45] = t8;
  } else {
    t8 = $[45];
  }
  let t9;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsNicRateOpen(false);
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  let t11;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsNicRateOpen(false);
    t11 = () => setIsNicRateOpen(false);
    $[47] = t10;
    $[48] = t11;
  } else {
    t10 = $[47];
    t11 = $[48];
  }
  let t12;
  if ($[49] !== profile) {
    t12 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} onSuccess={t10} onCancel={t11} />;
    $[49] = profile;
    $[50] = t12;
  } else {
    t12 = $[50];
  }
  let t13;
  if ($[51] !== profile || $[52] !== t12) {
    t13 = <div className="tw-px-4 sm:tw-px-6"><UserPageRateWrapper profile={profile} type={RateMatter.NIC}>{t12}</UserPageRateWrapper></div>;
    $[51] = profile;
    $[52] = t12;
    $[53] = t13;
  } else {
    t13 = $[53];
  }
  let t14;
  if ($[54] !== isNicRateOpen || $[55] !== t13) {
    t14 = <MobileWrapperDialog title="Rate NIC" isOpen={isNicRateOpen} onClose={t9} tabletModal={true} maxWidthClass="md:tw-max-w-md">{t13}</MobileWrapperDialog>;
    $[54] = isNicRateOpen;
    $[55] = t13;
    $[56] = t14;
  } else {
    t14 = $[56];
  }
  let t15;
  if ($[57] !== canEditRep || $[58] !== editCategory || $[59] !== profile) {
    t15 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[57] = canEditRep;
    $[58] = editCategory;
    $[59] = profile;
    $[60] = t15;
  } else {
    t15 = $[60];
  }
  let t16;
  if ($[61] !== t14 || $[62] !== t15 || $[63] !== t5 || $[64] !== t6 || $[65] !== t8) {
    t16 = <div>{t5}{t6}{t8}{t14}{t15}</div>;
    $[61] = t14;
    $[62] = t15;
    $[63] = t5;
    $[64] = t6;
    $[65] = t8;
    $[66] = t16;
  } else {
    t16 = $[66];
  }
  return t16;
}